export const constants = {
    isPrerendering: {
        name: 'isPrerendering',
        setQueryString: (urlSearchParams) => {
            urlSearchParams.set(constants.isPrerendering.name, `yes`);
            return urlSearchParams;
        },
        check: (urlSearchParams) => {
            return urlSearchParams.get(constants.isPrerendering.name) === 'yes';
        },
    },
};
//# sourceMappingURL=constants.js.map